<template>
  <div
    class="banner-component"
    :class="[type, variant]"
  >
    <p class="banner-text-content">
      <slot name="banner-text" />
    </p>
    <button
      class="action-button"
      @click="bannerClicked"
    >
      <slot name="banner-action" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    type: {
      type: String,
      default: 'app',
    },
    variant: {
      type: String,
      default: 'default',
    },
  },
  methods: {
    bannerClicked() {
      this.$emit('banner-clicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-component {
  background-color: #001c74;
  color: white;
  font-size: rem-calc(16);
  font-weight: $semi-bold;
  height: 58px;
  margin: 0;
  text-align: center;
  width: 100%;

  &.dashboard {
    margin-bottom: rem-calc(32);
    margin-top: rem-calc(-32);
    width: calc(100% + 4rem);
  }

  .banner-text-content {
    margin: rem-calc(18) 0 0; // Margin = total height (58) - font-size (16) / 2 (top & bottom spacing) and adjusted slightly
    display: inline-block;
  }

  .action-button {
    $accent-color: #ffd83e;
    background-color: transparent;
    text-transform: uppercase;
    color: $accent-color;
    padding: 0;
    font-weight: $semi-bold;
    font-size: rem-calc(14);
    letter-spacing: -.25px;
    display: inline-block;
    margin-left: rem-calc(4);
    border-bottom: 1px solid $accent-color;
  }

  @include breakpoint(small) {
    &.app {
      height: 80px;
    }

    .action-button {
      margin: rem-calc(4) auto 0;
      display: block;
    }
  }

  &.danger {
    background-color: #dc3416;

    .action-button {
      $accent-color: #ffffff;
      color: $accent-color;
      border-bottom: 1px solid $accent-color;
    }
  }
}
</style>
